(ns nosco.ui.banners
  (:require
   [hx.react :refer [defnc]]
   ["react-keyed-flatten-children" :default flatten-children]
   [nosco.react]
   [nosco.icons2 :as icons]))

(defnc Banner [{:keys [icon children inline on-close] :as props}]
  [:div
   (-> {:class ["nosco-banner"
                (when inline "nosco-banner--inline")]}
       (nosco.react/merge-props (dissoc props :icon :on-close :inline)))
   [:div {:class ["nosco-banner__icon"]}
    [icons/Icon {:icon icon}]]
   [:div
    children]
   (when on-close
     [:button {:class ["nosco-banner__close button-reset"] :on-click on-close}
      [icons/Icon {:icon icons/Close-small}]])])

(defnc BannerText [{:keys [children]}]
  [:div {:class ["nosco-banner__text"]}
   children])

(defnc BannerTitle [{:keys [children]}]
  [:div {:class ["nosco-banner__title"]}
   children])

(defnc BannerActions [{:keys [children]}]
  (into [:div {:class ["nosco-banner__actions"]}]
        (interpose [:span {:class ["px-2"]} "\u2022"])
        (flatten-children children)))

(defnc BannerActionButton [{:keys [label] :as props}]
  [:button (-> {:type "button"
                :class ["button-reset"]}
               (nosco.react/merge-props (dissoc props :label)))
   label])

(defnc BannerActionLink [{:keys [children] :as props}]
  [:a props children])

(defnc InformationalBanner [{:keys [children] :as props}]
  [Banner
   (-> {:class ["nosco-banner--informational"]
        :icon icons/Info-large}
       (nosco.react/merge-props props))
   children])

(defnc WarningBanner [{:keys [children] :as props}]
  [Banner
   (-> {:class ["nosco-banner--warning"]
        :icon icons/Semantic-Warning-large}
       (nosco.react/merge-props props))
   children])

(defnc CriticalBanner [{:keys [children] :as props}]
  [Banner
   (-> {:class ["nosco-banner--critical"]
        :icon icons/Semantic-Error-large}
       (nosco.react/merge-props props))
   children])

(defnc SuccessBanner [{:keys [children] :as props}]
  [Banner
   (-> {:class ["nosco-banner--success"]
        :icon icons/Check-large}
       (nosco.react/merge-props props))
   children])
